import { Component } from '@angular/core';

@Component({
  selector: 'app-job-timeline-skeleton',
  templateUrl: './job-timeline-skeleton.component.html',
  styleUrls: ['./job-timeline-skeleton.component.scss'],
})
export class JobTimelineSkeletonComponent {}
